import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';
import styled from 'styled-components';
import { theme } from "../../theme";
import { StyledAvatar, Avatar } from "./Avatar";
export var AvatarGroup = React.forwardRef(function (_ref, forwardedRef) {
  var count = _ref.count,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? 'grey10' : _ref$borderColor,
      childrenProp = _ref.children,
      other = _objectWithoutProperties(_ref, ["count", "borderColor", "children"]);

  var clampedMax = count < 2 ? 2 : count;
  var children = React.Children.toArray(childrenProp).filter(function (child) {
    return React.isValidElement(child);
  });
  var remainingAvatars = children.length > clampedMax ? children.length - clampedMax + 1 : 0;
  return /*#__PURE__*/React.createElement(StyledAvatarGroup, _extends({
    $borderColor: borderColor,
    ref: forwardedRef
  }, other), children.slice(0, children.length - remainingAvatars).map(function (child, i) {
    return React.cloneElement(child, {
      style: _objectSpread({
        zIndex: children.length - i
      }, child.props.style)
    });
  }), remainingAvatars > 0 && /*#__PURE__*/React.createElement(CountAvatar, {
    background: "brandPrimary",
    alt: "".concat(remainingAvatars, " others")
  }, "+", remainingAvatars));
});
var StyledAvatarGroup = styled.div.withConfig({
  displayName: "AvatarGroup__StyledAvatarGroup",
  componentId: "vapor__sc-1qb5fwb-0"
})(["display:flex;flex:0 0 auto;", "{box-sizing:content-box;border:2px solid ", ";margin-left:calc(", " * -1 - 2px);&:first-child{margin-left:0;}}"], StyledAvatar, function (p) {
  return theme.colors.palette[p.$borderColor];
}, theme.spaces[4]);
var CountAvatar = styled(Avatar).withConfig({
  displayName: "AvatarGroup__CountAvatar",
  componentId: "vapor__sc-1qb5fwb-1"
})(["min-width:24px;width:auto;border-radius:24px;"]);